import {
  Avatar,
  Col,
  colors,
  HoverCard,
  Icon,
  Row,
  Space,
  spacing,
  Text,
} from 'common-components';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useAppTranslation } from '@hooks';

const ContentContainer = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: ${spacing.padding.card.default}px;
`;
const SkillBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px 4px 10px;
  border-radius: 16px;
  background-color: ${colors.gray100};
`;
const FooterContainer = styled(Row)`
  width: 100%;
  height: 56px;
`;
const HoverContentContainer = styled(Row)`
  width: 100%;
  color: white;
`;

// TODO HIDE not remove
// const DraftBadgeContainer = styled.div`
//   position: absolute;
//   height: 50px;
//   width: 110px;
//   padding: 5px;
//   top: -45px;
//   right: -37px;
//   transform: rotate(45deg);
//   background-color: ${colors.gray600};
// `

type CardPropsType = {
  card: { name: string }
  onClick?: () => void
  style?: unknown
};

const Card = function ({ card, onClick, style }: CardPropsType) {
  const { translate } = useAppTranslation();

  return (
    <HoverCard
      ContentComponent={
        <ContentContainer>
          <Text size="md" color={colors.gray900} style={{ fontWeight: 500 }}>
            {card.name}
          </Text>
          {/*FIXME: should be only in conditions specified by BE. Disabled for now*/}
          {/*<DraftBadgeContainer>*/}
          {/*	<div*/}
          {/*		css={css`*/}
          {/*			margin-top: 2px;*/}
          {/*			display: flex;*/}
          {/*			flex-direction: column;*/}
          {/*			align-items: center;*/}
          {/*		`}*/}
          {/*	>*/}
          {/*		<Icon icon={"Lock01"} color={colors.white} />*/}
          {/*		<Text color={colors.white}>Réservé</Text>*/}
          {/*	</div>*/}
          {/*</DraftBadgeContainer>*/}
          <Space orientation="vertical">
            <SkillBadge>
              <Icon icon="ParagraphWrap" size={12} color={colors.gray700} />
              <Text color={colors.gray700} style={{ fontWeight: 500 }}>
                {translate('common.states.skill.5')}
              </Text>
            </SkillBadge>
            {/*<Text*/}
            {/*	css={css`*/}
            {/*		font-weight: 500 !important;*/}
            {/*		font-size: 12px;*/}
            {/*		line-height: 18px;*/}
            {/*		color: #2e90fa !important;*/}
            {/*	`}*/}
            {/*>*/}
            {/*	Fin du boost dans 3 heures*/}
            {/*</Text>*/}
          </Space>
        </ContentContainer>
      }
      footerContent={
        <FooterContainer align={'middle'} justify={'space-between'}>
          <Avatar size="xs" />
          {/*FIXME: NO DATA FOR SEGMENTS*/}
          {/*<div*/}
          {/*	css={css`*/}
          {/*		margin-left: 30px;*/}
          {/*	`}*/}
          {/*>*/}
          {/*	<IconAvatarGroup*/}
          {/*		avatars={card.segments.slice(0, 2).map((segment) => {*/}
          {/*			return {*/}
          {/*				size: "sm",*/}
          {/*				icon: "Scale02",*/}
          {/*				iconColor: colors.success500,*/}
          {/*				borderColor: colors.white,*/}
          {/*				iconBackground: colors.success300,*/}
          {/*			};*/}
          {/*		})}*/}
          {/*		maxCount={2}*/}
          {/*	/>*/}
          {/*</div>*/}
          <div
            css={css`
              display: flex;
              align-items: center;
              gap: 10px;
            `}
          >
            <Icon icon={'ClockStopwatch'} size={20} color={colors.gray600} />
            {/*<Text*/}
            {/*	css={css`*/}
            {/*		color: ${colors.gray600};*/}
            {/*	`}*/}
            {/*>*/}
            {/*	{card.duration}*/}
            {/*</Text>*/}
          </div>
        </FooterContainer>
      }
      hoverFooterContent={
        <HoverContentContainer align={'middle'} justify={'center'}>
          <Text color={colors.white} style={{ fontWeight: 500 }}>
            {translate('projects.contribute')}
          </Text>
        </HoverContentContainer>
      }
      onClick={onClick}
      style={style}
    />
  );
};

export default Card;
